import { Flex, Paper, Text } from "@mantine/core";
import { AttachmentModel } from "../types/attachment.types";
import CommentAttachment from "./CommentAttachment";

interface CommentAttachmentsProps {
  attachments: AttachmentModel[];
}

export default function CommentAttachments(
  { attachments }: CommentAttachmentsProps
) {
  return (
    <Paper bg="gray.1" p="xs">
      <Text tt="uppercase" size="xs" c="gray.8" fw={700} mb="xs">
        Attachments
      </Text>
      <Flex gap="md" wrap="wrap">
        {attachments.map(a => (
          <CommentAttachment key={a.id} attachment={a} />
        ))}
      </Flex>
    </Paper>
  );
}